// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__AwsH9","description":"MealItem_description__HeYwJ","price":"MealItem_price__3gPb6"};